var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { level: 2, styling: "page-title" } }, [
        _vm._v("Termine"),
      ]),
      _vm.isLoading
        ? _c("Paragraph", { staticClass: "is-loading" }, [
            _vm._v("Termine werden geladen…"),
          ])
        : _vm._e(),
      _vm.noEvents
        ? _c("Paragraph", { staticClass: "no-events" }, [
            _vm._v("Aktuell stehen keine Termine an."),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "events_wrapper" },
        _vm._l(_vm.currentEvents, function (event) {
          return _c("Event", {
            key: event.uid,
            attrs: {
              title: event.title,
              description: event.description,
              start: event.start,
              end: event.end,
              "is-all-day": event.isAllDay,
              location: event.location,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }